export * from './app-log.component';



// WEBPACK FOOTER //
// ./src/app/components/app-log/index.ts